
import Component, { mixins } from "vue-class-component"
import Calculator from "../mixins/Calculator.vue"
import IdRequest from "@/entities/common/request/id_request"

@Component
export default class ReservierungVorbestellungBearbeiten extends mixins(
  Calculator
) {
  logic: ReservierungVorbestellungBearbeitenLogic = null
}

class ReservierungVorbestellungBearbeitenLogic {
  init(id: string) {
    var request = new IdRequest()
    request.id = id
  }
}
